import { API_CONFIG } from '../config/api';

/**
 * Converts a relative image URL from the backend to a full URL
 * @param relativePath - The relative path from the backend (e.g., "/uploads/filename.jpg")
 * @returns Full URL or null if no path provided
 */
export function getFullImageUrl(relativePath: string | null | undefined): string | null {
  if (!relativePath) {
    return null;
  }
  
  // If it's already a full URL, return as is
  if (relativePath.startsWith('http://') || relativePath.startsWith('https://')) {
    return relativePath;
  }
  
  // Remove leading slash if present to avoid double slashes
  const cleanPath = relativePath.startsWith('/') ? relativePath.slice(1) : relativePath;
  
  const fullUrl = `${API_CONFIG.baseURL}/${cleanPath}`;
  
  // Debug logging
  console.log('Image URL Debug:', {
    relativePath,
    cleanPath,
    baseURL: API_CONFIG.baseURL,
    fullUrl
  });
  
  return fullUrl;
} 